@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div
    class="option-group-container spread-container"
    [ngClass]="[tupleClass, enableForSpread ? 'slider-spread-container' : '']"
    [style.--option-group-rows]="rows">
    @if (!enableForSpread) {
        <div class="option-group-header">
            <span>{{ firstParticipant }}</span>
            @if (numberOfOptions > 2) {
                <span>{{ sitecore.event.Tie }}</span>
            }
            <span>{{ secondParticipant }}</span>
        </div>
    }

    <ng-container *rxFor="let group of visibleOptionGroups | slice: 0 : effectiveVisibleLimit; trackBy: trackGroup">
        @for (option of group.options; track trackOption($index, option)) {
            @if (option) {
                <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option, index: $index, includeSliderValue: true }" />
            }
        }
    </ng-container>
</div>
@let visibility = spreadVisibility;
@if (visibility.showSlider) {
    <ms-market-slider
        class="slider"
        [steps]="sliderSteps"
        [centerValue]="centerValue"
        [isDisabled]="disableSlider"
        [rightLabel]="rightLabel"
        [leftLabel]="leftLabel"
        [identityKey]="optionGroup.id"
        (selectedValueChange)="setSliderCurrentValue($event)" />
}
@if (visibility.showExpandedView) {
    <ds-divider class="separator-line" />

    <div class="option-group-container spread-container slider-spread-container" [class]="tupleClass" [style.--option-group-rows]="rows">
        <ng-container *rxFor="let group of optionGroups; trackBy: trackGroup">
            @for (option of group.options; track trackOption($index, option)) {
                @if (option) {
                    <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option, index: $index, includeSliderValue: false }" />
                }
            }
        </ng-container>
    </div>
}
@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}

<ng-template #optionTemplate let-option let-index="index" let-includeSliderValue="includeSliderValue">
    <ms-option
        [tracking]="{ source: tracking, moduleType: trackingModuleType }"
        [option]="option"
        [optionGroup]="optionGroup"
        [event]="event"
        [showPromoBadge]="!!(option && crmPromoIdsMap.options[option.id])"
        [sourceOfPick]="sourceOfPick"
        [betDetails]="betDetails"
        [firstParticipant]="firstParticipant"
        [secondParticipant]="secondParticipant"
        [optionIndex]="index"
        [sliderValue]="includeSliderValue ? { currentValue: (currentValue$ | async) || 0, centerValue: centerValue } : undefined" />
</ng-template>
